<script setup>
defineProps({
  step: { type: Number, required: true },
  title: { type: String, required: true },
  description: { type: String, required: true },
  cta: { type: String, required: true },
  to: { type: String, required: true },
});
</script>

<template>
  <router-link
    :to="{ name: to }"
    class="group flex flex-col gap-3 p-5 bg-n-surface-1 border border-n-weak rounded-xl no-underline hover:border-n-brand hover:shadow-sm transition-all duration-150"
  >
    <span
      class="size-7 rounded-full bg-n-brand/10 text-n-brand text-xs font-bold flex items-center justify-center"
    >
      {{ step }}
    </span>
    <div class="flex flex-col gap-1">
      <p class="text-sm font-semibold text-n-slate-12 leading-snug">
        {{ title }}
      </p>
      <p class="text-sm text-n-slate-10 leading-relaxed">{{ description }}</p>
    </div>
    <span
      class="inline-flex items-center gap-1 text-sm font-medium text-n-brand mt-auto"
    >
      {{ cta }}
      <span
        class="i-lucide-arrow-right size-3.5 transition-transform duration-150 group-hover:translate-x-0.5"
      />
    </span>
  </router-link>
</template>
